import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default function Image(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          file(
            relativePath: { eq: "horticulture/horticulture-site-overview.png" }
          ) {
            childImageSharp {
              fluid(maxHeight: 500) {
                ...GatsbyImageSharpFluid_noBase64
              }
              fixed(width: 982) {
                src
              }
            }
          }
        }
      `}
      render={(data) => (
        <a href={data.file.childImageSharp.fixed.src}>
          <Img fluid={data.file.childImageSharp.fluid} {...props} />
        </a>
      )}
    />
  );
}
